import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const repollAndMarkRide = async (requestId: string) => {
  const response = await mutationExecute({
    variables: {
      requestId,
    },
    mutation: graphql(`
      mutation RepollAndMarkRide($requestId: String!) {
        repollAndMarkRide(requestId: $requestId) {
          id
          callerId
          dummyId
          driverId
          partnerId
          carId
          requestId
          scheduledRideId
          riderPhone
          vendor
          rideType
          orderedBy
          orderedById
          startLocation
          startLat
          startLong
          endLocation
          destination
          destinationLat
          destinationLng
          curLat
          curLng
          endLat
          endLong
          endNote
          duration
          durationEstimate
          distance
          map
          gogoMap
          createdAt
          driverName
          driverPhone
          driverPhoto
          driverCarImage
          driverPlate
          driverRating
          driverCancels
          driverTakingLongTime
          driverWaitMoreThan7Mins
          driverJoyRide
          driverCalls
          driverTexts
          driverChanges
          redispatches
          overrideBigCar
          overrideBadDriver
          callRiderDriverArriving
          noteToDriver
          status
          timeAccepted
          timeArriving
          timeInProgress
          timeCompleted
          timeReceiptReady
          timeCanceled
          timeCustomerCharged
          timePartnerCharged
          eta
          acceptedEta
          digitPressed
          switchedVendors
          skippedStatus
          wrongStatus
          receiptCall
          costPerMin
          costPerMile
          baseFare
          distanceFee
          timeFee
          normalFare
          bookingFee
          minimumFee
          surgeFactor
          surgeUrl
          surgeId
          subtotal
          totalFare
          gogoCost
          customerCost
          partnerCost
          customerCredits
          customerCreditsRefund
          partnerCredits
          partnerCreditsRefund
          gogoRevenue
          gogoFee
          customerRefund
          partnerRefund
          gogoMins
          customerCostOverride
          customerChargeId
          partnerChargeId
          partnerRefundId
          customerRefundId
          timeCustomerRefunded
          timePartnerRefunded
          timeCustomerCreditsRefunded
          timePartnerCreditsRefunded
          paymentTier
          transactionId
          originalReceipt
          note
          reason
          tip
          rating
          needLoveId
          updatedAt
          previousDrivers
        }
      }
    `),
  });

  return response.data!.repollAndMarkRide;
};
